//list-items.tsx

import React from "react";
import type { JSX } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  useTheme,
} from "@mui/material";

export const sidebarListItemSx = {
  py: 0.5,
  "& .MuiListItemIcon-root": {
    color: "black",
  },
};

export function ListItemLink(props: {
  icon: JSX.Element;
  iconEnd?: JSX.Element;
  to: string;
  primary: React.ReactNode;
  onClick: () => void;
  nested?: boolean;
}) {
  const { icon, iconEnd, primary, to, onClick, nested } = props;
  const location = useLocation();
  const theme = useTheme();

  // ✅ Active if current URL starts with this "to" path
  const isActive = location.pathname.startsWith(to);

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref: any) => {
        const { button, ...rest } = itemProps as any;

        return <RouterLink to={to} ref={ref} {...rest} />;
      }),
    [to],
  );

  return (
    <ListItem
      button
      onClick={onClick}
      component={renderLink as any}
      sx={{
        ...sidebarListItemSx,
        color: "black",
        pl: nested ? 4 : 2,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        backgroundColor: isActive ? "rgba(0, 128, 0, 0.1)" : "transparent",
        borderRadius: 1,
        transition: "background-color 0.2s ease-in-out",
      }}
    >
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={primary} />
      {iconEnd && <Icon>{iconEnd}</Icon>}
    </ListItem>
  );
}
